import { getMessages } from '../../../../../../../store/constants';

export const CUSTOM_ADD_CALENDAR = getMessages().getText('card_form_custom_section_item_calendar');
export const CUSTOM_HIDDEN = 'custom-property__push-to-google-calendar--hidden';
export const CUSTOM_ACTIONS_POPUP_PUSH = 'aside-panel-actions-popup--google-push';
